import HttpClient from '../services/HttpClient';
import axios from 'axios';

const instancia = axios.create();
instancia.CancelToken = axios.CancelToken;
instancia.isCancel = axios.isCancel;


export const crearTrace = async (trace)=>{
    try {
        const response = await instancia.post("/api/propertytraces", trace);
        return response;
    } catch (error) {
        // Si hay error de conexión, `error.response` podría ser undefined
        return error.response || {
            status: 500,
            data: { message: "Network error" }
        };
    }
}

export const getTracesByPropertyId = async (id) => {
     try {
        const response = await instancia.get(`/api/propertytraces/by-property/${id}`);
        return response;
    } catch (error) {
        // Si hay error de conexión, `error.response` podría ser undefined
        return error.response || {
            status: 500,
            data: { message: "Network error" }
        };
    }
}